// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__-yeC+","title":"Heading_title__bsFCj","arrow":"Heading_arrow__KEzDw","jumpInfinite":"Heading_jumpInfinite__i927O","continue":"Heading_continue__QnWH+"};